import CircularProgress from '@mui/material/CircularProgress';

export default function CentralSpinner() {
    return <div style={{display: "flex", justifyContent: "center", marginTop: "5em"}}>
        <CircularProgress style={{color: '#31924b'}} />
    </div>
}